import { Properties } from '@crm/types'

export const defaultFilters: Properties = {
  page: 1,
  per_page: 10
}

export const defaultNonPagination: Properties = {
  page: 1,
  per_page: 100
}

export const getActiveFiltersCount = (
  countedFilters: string[],
  filters: Properties
) => {
  return countedFilters?.filter((filter) => filters?.[filter]?.[0])?.length
}

export const defaultFiltersMultipleValues = (
  params: Properties,
  isNumber = false
) => {
  if (!params) return undefined

  const values = (Array.isArray(params) ? params : [params])
    .flatMap((v) => String(v).split(','))
    .map((v) => v.trim())
    .filter(Boolean)

  if (!values.length) return undefined

  return isNumber
    ? values.map(Number).filter((n) => Number.isFinite(n))
    : values
}

export const defaultFiltersNumberValues = (params: string) =>
  params ? Number(params) : undefined
